import { loadScript } from './loadScript'
import { onConsentChange } from './consent'

let initialised = false

const initHubspot = (): void => {
  if (initialised || typeof window === 'undefined') {
    return
  }
  const portalId = process.env.GATSBY_HUBSPOT_PORTAL_ID
  if (!portalId) {
    return
  }
  initialised = true

  try {
    window._hsq = window._hsq || []

    loadScript('hs-script-loader', `https://js.hs-scripts.com/${portalId}.js`)
  } catch {
    // A broken HubSpot loader must never break page rendering (FR-012).
  }
}

export const registerHubspotLoader = (): void => {
  onConsentChange((state) => {
    if (state.marketing) {
      initHubspot()
    }
  })
}
